<template>
  <!-- Manage Board Modal -->
  <form @submit.prevent="handleFormSubmit">
    <BaseModal @close="$emit('close')">
      <template #toolbar>
        <div class="bg-white flex w-full rounded-md gap-x-3 -mb-3">
          <img
            src="../../assets/icons/new-folder-icon.svg"
            alt=""
          >
          <!-- Right Side -->
          <div class="transform -translate-y-0.5">
            <div class="text-lg font-semibold">
              Create Folder {{ lens?.name ? 'for ' + lens.name : '' }}
            </div>
            <div class="text-sm text-gray-500">
              {{ 
                lens?.id 
                  ? 'Folders will keep your reports organized within this Lens' 
                  : 'Folders keep your boards organized'
              }}
            </div>
          </div>
        </div>
      </template>

      <template #default>
        <div class="border-t border-border-normal">
          <BaseInputV2
            v-model="folderName"
            label="Folder Name"
            :placeholder="lens?.id ? 'Client Reports' : 'Client Boards'"
            class="mt-5 mx-5"
          />
          <div class="w-full h-0 border-t border-border-normal my-5" />
          <div class="mx-5" style="height: 32px">
            <BaseButton
              primary
              :loading="loading"
              :disabled="!folderName.length || folderName === 'Default'"
              class="ml-auto"
              type="submit"
            >
              Create Folder
            </BaseButton>
          </div>
        </div>
      </template>
    </BaseModal>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FirebaseAPI from '@/api/firebase'
import LensAPI from '@/api/lens'

export default {
  name: 'FolderModal',
  props: {
    lens: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      folderName: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['isFreeTier', 'getTeam']),
    ...mapGetters('BoardsModule', ['getBoards'])
  },
  mounted () {},
  methods: {
    ...mapActions('BoardsModule', ['fetchBoards', 'fetchFolders']),
    ...mapActions('LensModule', ['fetchSidebarLenses']),
    handleFormSubmit () {
      if (this.lens?.id) {
        this.handleCreateLensFolder()
      } else {
        this.handleCreateFolder()
      }
    },
    async handleCreateFolder () {
      this.loading = true

      const folderPayload = {
        name: this.folderName,
        boardIds: [],
        createdAt: +new Date()
      }

      // Check for team
      if (this.getTeam) {
        folderPayload.teamId = this.getTeam.id
      }
      await FirebaseAPI.Folders.create(folderPayload)

      // Refetch the boards and folders for the sidebar
      this.fetchFolders()

      // finished actions
      this.loading = false
      this.$emit('close')
    },
    async handleCreateLensFolder () {
      this.loading = true
      if (this.folderName === 'Default') return
      try {
        await LensAPI.LensFolder.create(this.lens.id, this.folderName)
        await this.fetchSidebarLenses()
        this.$showAlert({ type: 'success', message: 'Folder created successfully' })
      } catch (error) {
        console.error('Error creating lens folder:', error)
        this.$showAlert({ type: 'error', message: 'Report creation failed. See console for details' })
      } finally {
        this.loading = false
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped></style>
